<template lang="html">
<div class="pgInner announcement">

    <div class="headBar">
        <span v-if="type==1">新建文章解读</span>
        <span v-if="type==2">新建信息图解读</span>
        <span v-if="type==3">新建视频解读</span>
    </div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="false">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">关联政策</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-select
                                 class="inpText"
                                 v-model="params.cqjSbzcDeclarationPolicyId"
                                 filterable
                                 remote
                                 placeholder="请输入关键词"
                                 size="medium"
                                 :remote-method="goSeek"
                                 :loading="loading">
                                 <el-option
                                   v-for="item in pocList"
                                   :key="item.id"
                                   :label="item.title"
                                   :value="item.id">
                                 </el-option>
                               </el-select>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">解读标题</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                                <el-input size="medium" class="inpText" v-model="params.title" placeholder="请输入标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">来源</div>
                     <div class="bContent">
                           <el-form-item prop="publishingDepartmentNames">
                                <el-input size="medium" class="inpText" v-model="params.publishingDepartmentNames" placeholder="请输入发文机构"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div v-if="params.type==1" class="text-block clearfix">
                     <div class="bName">概要</div>
                     <div class="bContent">
                           <el-form-item prop="description">
                                <el-input style="width:420px;" rows="5" type="textarea" v-model="params.description" placeholder="请输入"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div v-if="params.type==1" class="text-block scene-block clearfix">
                     <div class="bName">内容</div>
                     <div class="bContent">
                         <textEditor ref="textEditor" :inContent="params.content" />
                     </div>
                 </div>

                 <div v-if="params.type==2" class="text-block clearfix">
                     <div class="bName">信息图</div>
                     <div class="bContent">
                           <imgs-upload :files="params.videoContentId" @fileChange="fileChange" />
                     </div>
                 </div>

                 <div v-if="params.type==3" class="text-block mv-block clearfix">
                     <div class="bName">视频</div>
                     <div class="bContent">
                           <mv-upload :files="params.videoContentId" @fileChange="fileChange" />
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">封面图</div>
                     <div class="bContent">
                           <img-upload :image="params.image" @imgChange="imgChange" tips="（345*140推荐）" />
                     </div>
                 </div>


               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

        <el-button @click="directSave(1)" type="primary" size="small">立即发布</el-button>
        <el-button @click="directSave(2)" plain size="small">存为草稿</el-button>
        <el-button @click="goReturn" plain size="small">取消</el-button>

    </div>

</div>
</template>

<script>
import { decList,decPredat } from "@/api/declare/declare";
import { unsCreate,unsPredat } from "@/api/unscramble/index";
import Editor from "@/components/KindEditor/KindEditor";
import mvUpload from "./src/mvUpload";
export default {
    components:{
        Editor,
        mvUpload
    },
    data(){
        return{
            pageH:'',

            pocList:[],

            params:{
                id:'',
                cqjSbzcDeclarationPolicyId:'',
                title:'',
                publishingDepartmentNames:'',
                description:'',
                type:1,
                image:'',
                content:'',
                videoContentId:''
            },

            preCode:'',
            pgName:'',

            rules:{
                cqjSbzcDeclarationPolicyId:[{
                      required: true,
                      message: '不能为空',
                      trigger: 'change'
                }],
                title:[{
                      required: true,
                      message: '不能为空',
                      trigger: 'blur'
                }],
                publishingDepartmentNames:[{
                      required: true,
                      message: '不能为空',
                      trigger: 'blur'
                }],
                description:[{
                      required: true,
                      message: '不能为空',
                      trigger: 'blur'
                }]
            }

        }
    },

    methods:{
        goSeek:function(e){
            var vues = this;
            decList({
                declarationPolicyCondition:{
                  keyword:e,
                  status:1,
                  sort:2
                },
                size:20,
                no:1
            }).then(res => {
                vues.pocList = res.declarationPolicyList;
            })
        },
        fileChange:function(e){    //  附件
            if(e.length > 0){
               this.params.videoContentId = JSON.stringify(e);
            }else{
               this.params.videoContentId = '';
            }
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },
        selectChange:function(eDat){   //  数据字典
            this.params.status = eDat.id;
        },

        contentChange:function(e){    // 富文本内容
            this.params.content = e;
        },

        goCreate:function(status){  // 创建
            var vues = this;
            this.params.status = status;

            unsCreate({postInterpretation:this.params}).then(res => {
                vues.$router.push('uns_list');
            }).catch(err => {})
        },


        directSave:function(status){
            var vues = this;
            vues.params.content = vues.$refs.textEditor.editorContent;
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    vues.goCreate(status);
                }
            })
        },

        imgChange:function(e){
            this.params.image = e;
        },

        goReturn:function(){
            this.$router.push('uns_list');
        },

        preSeek:function(id){
            var vues = this;
            decPredat({id:id}).then(res => {
                var unFormate = res.declarationPolicy;
                this.params.cqjSbzcDeclarationPolicyId = unFormate.id;

                vues.goSeek(unFormate.title);
            })
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;
            this.params.type = querys.type;

            // 底部定位
            this.pageFix();

            if(querys){
                if(querys.id){
                    this.params.id = querys.id;
                    unsPredat({id:querys.id}).then(res => {
                        vues.params = res.postInterpretation;
                        vues.preSeek(res.postInterpretation.cqjSbzcDeclarationPolicyId);
                    })
                }else if(querys.pid){
                    vues.preSeek(querys.pid);
                }else{
                    vues.goSeek();
                }
            }

        },
    },
    created:function(){
        var vues = this;

        this.prevSet();

        $(window).on('resize',function(){
    		     vues.pageFix();
             vues.$refs.scroller.$data.sizeHeight = this.pageH;
    	  })

    },

    beforeDestroy:function(){
        clearInterval(this.waitSave);
        $(window).off('resize');
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.mv-block{
   margin: 20px 0;
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 80px;
          padding-top: 8px;
          float: left
     }
     .bContent{
          margin-left: 80px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
               width: 420px;
          }
     }

}

.enclosure{
   margin-top: 20px;
   margin-bottom: 45px;
  .ttl{
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
  }
  .ecContent{
    margin-left: 60px;
  }

}

</style>

<style lang="css">

.announcement .el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// unsEdit.vue?597d61e2